import React from 'react';
import PropTypes from 'prop-types';
import NBABL from '../nba/NBABL';
import HeroCard from '../nba/HeroCard';
import { homepageAdvertsList } from './HomepageAdvertsList';
import ActivateHardTokenTile from './ActivateHardTokenTile';
import homepageTilesAccounts from './HomepageTilesAccounts';
import homepageNonAccountTiles from './HomepageNonAccountTiles';

function HomepageTiles({
  includeAccounts,
  accounts,
  content,
  className,
  nbaData,
  invokeModal,
  advertClick,
  goToAccountDetails,
  shouldActivateHardToken,
  handleActivateTokenClick,
  messageCount,
  isLCV,
}) {
  return (
    <section className={className}>
      {includeAccounts
        ? homepageTilesAccounts({
            accounts,
            goToAccountDetails,
            content,
            updates: nbaData.getUpdates(),
            products: nbaData.getProducts(),
            invokeModal,
          })
        : homepageNonAccountTiles({
            updates: nbaData.getUpdates(),
            products: nbaData.getProducts(),
            invokeModal,
          })}
      {shouldActivateHardToken && (
        <ActivateHardTokenTile
          content={content}
          onClick={handleActivateTokenClick}
        />
      )}
      {homepageAdvertsList({ advertClick, messageCount, content, isLCV })}
      {NBABL.getBannerComponent(
        <HeroCard data={nbaData.getHeros()} action={invokeModal} />
      )}
      {NBABL.getBannerComponent(
        <HeroCard data={nbaData.getBanners()} action={invokeModal} />
      )}
    </section>
  );
}

HomepageTiles.propTypes = {
  includeAccounts: PropTypes.bool.isRequired,
  accounts: PropTypes.array.isRequired,
  content: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  nbaData: PropTypes.object.isRequired,
  invokeModal: PropTypes.func.isRequired,
  advertClick: PropTypes.func.isRequired,
  goToAccountDetails: PropTypes.func.isRequired,
  shouldActivateHardToken: PropTypes.bool.isRequired,
  handleActivateTokenClick: PropTypes.func.isRequired,
  count: PropTypes.number,
};

export default HomepageTiles;
